<template>
  <v-data-table
    :headers="headers"
    :items="dailyActivities"
    :items-per-page="15"
    :single-expand="true"
    show-expand
    :mobile-breakpoint="dataTableMobileBreakpoint"
    :sort-by="sortBy"
    :group-by="groupBy"
    dense
    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <div class="d-flex text-start pa-4">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-timer</v-icon>Activities
        </span>
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-0 ma-0"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div>
    </template>
    <template v-slot:group.header="props">
      <td
        class="text-start pa-2 font-weight-medium"
        :colspan="props.headers.length"
      >
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-icon left>mdi-ferry</v-icon>
              {{ props.group }}
            </span>
          </template>
          Vessel: {{ props.group }}
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.startDateTimeLt="{ item }">
      <span v-if="!item.startDateTimeLt"></span>
      <span else>{{
        item.startDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
    </template>
    <template v-slot:item.endDateTimeLt="{ item }">
      <span v-if="!item.endDateTimeLt">Ongoing</span>
      <span else>{{
        item.endDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
    </template>
    <template v-slot:item.deckSpaceUsed="{ item }">
      <span>{{ item.deckSpaceUsed }}%</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="text-start pa-4">
        <div class="my-2">
          <span class="font-weight-bold">Vessel Comment:</span>
          <div>{{ item.vesselComment }}</div>
        </div>
        <div class="my-2">
          <span class="font-weight-bold">Verification Comment:</span>
          <div>{{ item.verificationComment }}</div>
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';

export default {
  name: 'DailyVoyageReportVoyageTable',
  mixins: [ResponsiveSizeHelperMixin],
  props: {
    dailyActivities: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Vessel', value: 'vesselName' },
        { text: 'Voyage No', value: 'voyageNo' },
        { text: 'Start (LT)', value: 'startDateTimeLt' },
        { text: 'End (LT)', value: 'endDateTimeLt' },
        { text: 'Activity', value: 'activityName' },
        { text: 'Code', value: 'code' },
        { text: 'Activity Type', value: 'activityType' },
        { text: 'Location', value: 'locationName' },
        { text: 'Sailing Distance (NM)', value: 'distanceSailed' },
        { text: 'Used Deckspace (%)', value: 'deckSpaceUsed' },
        { text: '', value: 'data-table-expand' },
      ],
      sortBy: ['vesselName', 'voyageNo'],
      groupBy: 'vesselName',
    };
  },
};
</script>
